function Cookie() {
	const cookieContainer = document.getElementById('site-cookie-bar');
	const cookie = getCookie("cookie") ? true : false;
	let cookieClose = null;
	let cookieAccept = null;

	if (cookieContainer) {
		cookieClose = cookieContainer.querySelector('.cookie-bar__close');
		cookieAccept = cookieContainer.querySelector('.cookie-bar__accept');
	}

    function getCookie(cName) {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie);
        const cArr = cDecoded .split('; ');
        let res;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        })
        return res;
  	}

	function fade(element) {
		let op = 1;
		const timer = setInterval(function () {
			if (op <= 0.1){
				clearInterval(timer);
				element.style.display = 'none';
			}
			element.style.opacity = op;
			element.style.filter = 'alpha(opacity=' + op * 100 + ")";
			op -= op * 0.1;
		}, 10);
	}

	if (cookieContainer) {
		if (cookie) {
			cookieContainer.style.display = 'none';
		} else {
			cookieContainer.style.display = 'block';
		}
	}

	//Close cookie item and set local storage
	if (cookieClose) {
		cookieClose.addEventListener('click', function (e) {
			e.preventDefault();
			document.cookie = "cookie=true; path=/";
			fade(cookieContainer);
		});
	}
	if (cookieAccept) {
		cookieAccept.addEventListener('click', function (e) {
			e.preventDefault();
			document.cookie = "cookie=true; path=/";
			fade(cookieContainer);
		});
	}
}

export default Cookie;
